var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.5,53.3l-6.2,12.2H92.6c-15.1,0-27.2,12.2-27.2,27.2s12.2,27.2,27.2,27.2h326.7c15.1,0,27.2-12.2,27.2-27.2 s-12.2-27.2-27.2-27.2h-81.7l-6.1-12.2c-4.6-9.3-14.1-15.1-24.4-15.1H204.8C194.5,38.2,185,44,180.5,53.3z M419.4,147.1H92.6 l18.1,288.4c1.4,21.5,19.2,38.3,40.7,38.3h209.1c21.5,0,39.4-16.8,40.7-38.3L419.4,147.1z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Trash.80e2ca5f5a7bc9b7e83ed269e23e60e9.svg";